/* Pagination dots for the mobile swipe tracks.
 *
 * The CSS already turns a .lum-swipe grid into a scroll-snap track under
 * 750px with no JS at all -- this only adds the dots and keeps them in sync.
 *
 * Self-guards on window.lumCarouselReady so several sections can each include
 * the script tag without wiring everything twice.
 *
 * The dots container must be a SIBLING of the track: we walk
 * track.parentNode, so nesting [data-lum-dots] anywhere else silently does
 * nothing. That is documented in lum-brand.css too.
 */
(function () {
  if (window.lumCarouselReady) return;
  window.lumCarouselReady = true;

  function init(track) {
    var parent = track.parentNode;
    if (!parent) return;
    var dots = parent.querySelector('[data-lum-dots]');
    if (!dots || dots.dataset.lumBound === '1') return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    dots.dataset.lumBound = '1';
    dots.innerHTML = '';

    slides.forEach(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1));
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    var buttons = Array.prototype.slice.call(dots.children);
    var raf = null;

    // Tracks that show several cards at once and snap to the LEFT edge (the
    // desktop review slider) are measured from the left, and dots for cards
    // that can never reach the left edge are hidden -- otherwise dot 2 lights
    // up at the start and the last dots are dead. One-card centre-snap tracks
    // (phones) keep the original centre measurement.
    function startAligned() {
      return (getComputedStyle(slides[0]).scrollSnapAlign || '').indexOf('start') === 0;
    }
    function offset(s) { return s.offsetLeft - track.offsetLeft; }

    function sync() {
      var start = startAligned();
      var maxScroll = track.scrollWidth - track.clientWidth;
      var best = 0, bestD = Infinity;
      slides.forEach(function (s, i) {
        var reachable = !start || offset(s) <= maxScroll + 2;
        buttons[i].style.display = reachable ? '' : 'none';
        if (!reachable) return;
        var d = start
          ? Math.abs(offset(s) - track.scrollLeft)
          : Math.abs(offset(s) + s.offsetWidth / 2 - (track.scrollLeft + track.clientWidth / 2));
        if (d < bestD) { bestD = d; best = i; }
      });
      // At the far right, the last reachable dot is the active one.
      if (start && track.scrollLeft >= maxScroll - 2) {
        for (var j = slides.length - 1; j >= 0; j--) {
          if (buttons[j].style.display !== 'none') { best = j; break; }
        }
      }
      buttons.forEach(function (b, i) {
        if (i === best) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }

    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-lum-track]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Re-run when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', boot);
})();
